import { RECURRENCE_BUCKETS, groupSourcesByBucket, sortSources, sumBucketAmount } from './incomeSourceBuckets';
import pt from '../locales/pt';

export function buildIncomeSourcesPageModel({ sources = [] }) {
  const activeSources = sources.filter((source) => source.is_active !== false);
  const groupedSources = groupSourcesByBucket(activeSources);
  const groups = RECURRENCE_BUCKETS.map((bucket) => {
    const bucketSources = sortSources(groupedSources[bucket.id] || []);
    return {
      bucket,
      sources: bucketSources,
      totalEur: sumBucketAmount(bucketSources),
      label: pt.income.sources.buckets[bucket.labelKey],
    };
  }).filter((group) => group.sources.length > 0);

  return {
    totalEur: sumBucketAmount(activeSources),
    groups,
  };
}
